module.exports = __webpack_public_path__ + "static/media/audi_zertifikat_2016.d5834698.jpg";